/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Contact_Info_TitleInputs */

const vi_customer_contact_info_title = /** @type {(inputs: Customer_Contact_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin liên hệ`)
};

/**

* @param {Customer_Contact_Info_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_contact_info_title = /** @type {((inputs?: Customer_Contact_Info_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Contact_Info_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_contact_info_title(inputs)
});